export function showQualificationOverlay() {
    const overlay = document.getElementById('qualification-overlay')
    const closeBtn = overlay.querySelector('.close-btn')

    overlay.style.display = 'block'

    // Falls mehrfaches Anhängen verhindert werden soll:
    closeBtn.onclick = () => {
        overlay.style.display = 'none'
    }
}
